import type { CategoryHue } from '@recipes/contracts';

/**
 * The ten category hues as class names (docs/partial/appearance-and-themes-spec.md 6.4).
 * Written out, because Tailwind only generates what it can read; the colours themselves are
 * tokens and follow theme and mode. Colour is never the only carrier: every coloured element
 * keeps its label or icon.
 */
export const HUES: readonly CategoryHue[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

/** Soft background with the readable text colour on it. */
export const HUE_SURFACE: Record<CategoryHue, string> = {
  1: 'bg-cat-1-surface text-cat-1-foreground',
  2: 'bg-cat-2-surface text-cat-2-foreground',
  3: 'bg-cat-3-surface text-cat-3-foreground',
  4: 'bg-cat-4-surface text-cat-4-foreground',
  5: 'bg-cat-5-surface text-cat-5-foreground',
  6: 'bg-cat-6-surface text-cat-6-foreground',
  7: 'bg-cat-7-surface text-cat-7-foreground',
  8: 'bg-cat-8-surface text-cat-8-foreground',
  9: 'bg-cat-9-surface text-cat-9-foreground',
  10: 'bg-cat-10-surface text-cat-10-foreground',
};

/** The solid hue: dots, bars and icons. */
export const HUE_SOLID: Record<CategoryHue, string> = {
  1: 'bg-cat-1',
  2: 'bg-cat-2',
  3: 'bg-cat-3',
  4: 'bg-cat-4',
  5: 'bg-cat-5',
  6: 'bg-cat-6',
  7: 'bg-cat-7',
  8: 'bg-cat-8',
  9: 'bg-cat-9',
  10: 'bg-cat-10',
};

export const HUE_TEXT: Record<CategoryHue, string> = {
  1: 'text-cat-1',
  2: 'text-cat-2',
  3: 'text-cat-3',
  4: 'text-cat-4',
  5: 'text-cat-5',
  6: 'text-cat-6',
  7: 'text-cat-7',
  8: 'text-cat-8',
  9: 'text-cat-9',
  10: 'text-cat-10',
};

export const HUE_BORDER: Record<CategoryHue, string> = {
  1: 'border-cat-1',
  2: 'border-cat-2',
  3: 'border-cat-3',
  4: 'border-cat-4',
  5: 'border-cat-5',
  6: 'border-cat-6',
  7: 'border-cat-7',
  8: 'border-cat-8',
  9: 'border-cat-9',
  10: 'border-cat-10',
};
